module.exports = __webpack_public_path__ + "img/boringweather.ca37c1d5.png";